import { TagDetail } from '@pages/tag/_shared/TagDetail'

const GradingTagDetail = () => <TagDetail tagSourceType="grading" />

export default GradingTagDetail
